import axios from 'axios'
import store from '../store'
import router from '../router'

// 创建axios实例
const customAxios = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL,
  timeout: 20000
})

customAxios.interceptors.request.use(function (config) {
  // console.info(config)
  if (store.state.token) {
    config.headers.Authorization = store.state.token
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

customAxios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    alert('授权失败')
    sessionStorage.clear()
    localStorage.clear()
    store.state.userInfo = null
    store.state.menuList = null
    router.push('/login')
    return Promise.reject(error)
  } else {
    alert('Error: ' + error.response.status + ' ' + error.response.statusText)
    return Promise.reject(error)
  }
})

export default customAxios
